/** 
 * Index for default customer 
*/
/* eslint-disable vue/multi-word-component-names */
/* eslint-disable vue/no-reserved-component-names */
import { createApp } from 'vue'
import App from '@/App.vue'
import CoreRouter from '@/core/router/router';
import KrediflowInvite from './components/Krediflow-Invite.vue'
import KrediflowExternal from './components/Krediflow-External.vue'
import {
    InboxIcon
} from '@heroicons/vue/24/outline';
import {
    Square3Stack3DIcon
} from '@heroicons/vue/24/outline';
import '@/core/assets/primevue/neuraxis.css';
import Krediflow from './components/Krediflow-Inbox.vue';
import Settings from './components/Krediflow-Settings.vue';
import DataHub from '@/core/components/User/Admin/Admin-Datahub.vue';
import { RouteAdd, RouteAddtoDashboard, DashboardAddLink } from '@/core/var/router';
const customer = require('./config/config');
import '@/core/var/axios';
import './assets/font.css';
import { useCustomerStore } from '@/core/store/CustomerStore';
import { useAuthStore } from '@/core/store/AuthStore';
import { createPinia } from 'pinia'; const pinia = createPinia();
import PrimeVue from 'primevue/config'
import Tooltip from 'primevue/tooltip'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Toast from 'primevue/toast'
import Breadcrumb from 'primevue/breadcrumb'
import Menubar from 'primevue/menubar'
import Splitter from 'primevue/splitter'
import SplitterPanel from 'primevue/splitterpanel'
import Panel from 'primevue/panel'
import OrderList from 'primevue/orderlist'
import AutoComplete from 'primevue/autocomplete'
import OverlayPanel from 'primevue/overlaypanel'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Fieldset from 'primevue/fieldset'
import Divider from 'primevue/divider'
import Card from 'primevue/card'
import Badge from 'primevue/badge'
import BadgeDirective from 'primevue/badgedirective'
import Ripple from 'primevue/ripple'
import Dropdown from 'primevue/dropdown'
import MultiSelect from 'primevue/multiselect'
import ProgressSpinner from 'primevue/progressspinner'
import BlockUI from 'primevue/blockui'
import Chips from 'primevue/chips'
import StyleClass from 'primevue/styleclass'
import Textarea from 'primevue/textarea'
import Calendar from 'primevue/calendar'
import TreeSelect from 'primevue/treeselect'
import InputSwitch from 'primevue/inputswitch'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Avatar from 'primevue/avatar'
import AvatarGroup from 'primevue/avatargroup'
import Chip from 'primevue/chip'
import Checkbox from 'primevue/checkbox'
import Tag from 'primevue/tag'
import SpeedDial from 'primevue/speeddial'
import Menu from 'primevue/menu'
import Sidebar from 'primevue/sidebar'
import Message from 'primevue/message'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import RadioButton from 'primevue/radiobutton'
import SelectButton from 'primevue/selectbutton'
import ConfirmDialog from 'primevue/confirmdialog'
import FileUpload from 'primevue/fileupload'
import ToggleButton from 'primevue/togglebutton'
import TreeTable from 'primevue/treetable'
import Editor from 'primevue/editor'
import SplitButton from 'primevue/splitbutton'
import Toolbar from 'primevue/toolbar'
import Galleria from 'primevue/galleria'
import ScrollPanel from 'primevue/scrollpanel'
import ContextMenu from 'primevue/contextmenu'
import Password from 'primevue/password'
import InlineMessage from 'primevue/inlinemessage'
import Inplace from 'primevue/inplace'

RouteAddtoDashboard({ name: 'Krediflow', position: 'dashboard-left' }, Krediflow, CoreRouter);

const krediflow_invite_link = 'invite'
RouteAdd(krediflow_invite_link, KrediflowInvite, CoreRouter)
const krediflow_external_link = 'ext'
RouteAdd(krediflow_external_link, KrediflowExternal, CoreRouter)

RouteAddtoDashboard({ name: 'Einstellungen', position: 'dashboard-left' }, Settings, CoreRouter);
const data_hub_link = 'datahub';
RouteAdd(data_hub_link, DataHub, CoreRouter);
DashboardAddLink({ name: 'Data Hub', href: `/${data_hub_link}`, icon: Square3Stack3DIcon, order: 10 });


const neuraxisApp = createApp(App);

neuraxisApp.use(pinia);

const customerStore = useCustomerStore();
customerStore.setCustomer(customer);

const auth = useAuthStore();

neuraxisApp.use(CoreRouter);

//optional
neuraxisApp.use(PrimeVue, { ripple: true });
neuraxisApp.use(ToastService);
neuraxisApp.use(ConfirmationService);
neuraxisApp.directive('Tooltip', Tooltip);
neuraxisApp.directive('badge', BadgeDirective);
neuraxisApp.directive('ripple', Ripple);
neuraxisApp.directive('styleclass', StyleClass);

neuraxisApp.component('Dialog', Dialog);
neuraxisApp.component('InputText', InputText)
neuraxisApp.component('Button', Button)
neuraxisApp.component('Toast', Toast)
neuraxisApp.component('ConfirmDialog', ConfirmDialog)
neuraxisApp.component('Breadcrumb', Breadcrumb)
neuraxisApp.component('Menubar', Menubar)
neuraxisApp.component('Splitter', Splitter)
neuraxisApp.component('SplitterPanel', SplitterPanel)
neuraxisApp.component('Panel', Panel)
neuraxisApp.component('OrderList', OrderList)
neuraxisApp.component('AutoComplete', AutoComplete)
neuraxisApp.component('OverlayPanel', OverlayPanel)
neuraxisApp.component('DataTable', DataTable)
neuraxisApp.component('Column', Column)
neuraxisApp.component('Fieldset', Fieldset)
neuraxisApp.component('Divider', Divider)
neuraxisApp.component('Card', Card)
neuraxisApp.component('Badge', Badge)
neuraxisApp.component('Dropdown', Dropdown)
neuraxisApp.component('MultiSelect', MultiSelect)
neuraxisApp.component('ProgressSpinner', ProgressSpinner)
neuraxisApp.component('BlockUI', BlockUI)
neuraxisApp.component('InputNumber', InputNumber)
neuraxisApp.component('Chips', Chips)
neuraxisApp.component('Textarea', Textarea)
neuraxisApp.component('Calendar', Calendar)
neuraxisApp.component('TreeSelect', TreeSelect)
neuraxisApp.component('InputSwitch', InputSwitch)
neuraxisApp.component('TabView', TabView)
neuraxisApp.component('TabPanel', TabPanel)
neuraxisApp.component('Avatar', Avatar)
neuraxisApp.component('AvatarGroup', AvatarGroup)
neuraxisApp.component('Chip', Chip)
neuraxisApp.component('Checkbox', Checkbox)
neuraxisApp.component('InputMask', InputMask)
neuraxisApp.component('Tag', Tag)
neuraxisApp.component('SpeedDial', SpeedDial)
neuraxisApp.component('Menu', Menu)
neuraxisApp.component('Sidebar', Sidebar)
neuraxisApp.component('Message', Message)
neuraxisApp.component('Accordion', Accordion)
neuraxisApp.component('AccordionTab', AccordionTab)
neuraxisApp.component('RadioButton', RadioButton)
neuraxisApp.component('SelectButton', SelectButton)
neuraxisApp.component('FileUpload', FileUpload)
neuraxisApp.component('ToggleButton', ToggleButton)
neuraxisApp.component('TreeTable', TreeTable)
neuraxisApp.component('Editor', Editor)
neuraxisApp.component('SplitButton', SplitButton)
neuraxisApp.component('Toolbar', Toolbar)
neuraxisApp.component('Galleria', Galleria)
neuraxisApp.component('ScrollPanel', ScrollPanel)
neuraxisApp.component('ContextMenu', ContextMenu)
neuraxisApp.component('Password', Password)
neuraxisApp.component('InlineMessage', InlineMessage)
neuraxisApp.component('Inplace', Inplace)

neuraxisApp.mount('#app');